/**
 * Created by Andrey Popov on 2/1/22.
 */

const PassWindowContent = cc.Node.extend({
    ctor: function (options) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(options.width, options.styles.height);

        options.components.forEach((description) => {
            const styles = options.styles[description.name];

            const parameters = Object.assign(description.params || {}, {
                passLogic: options.passLogic,
                width: options.width,
                styles
            });

            if (description.class.IsActive && !description.class.IsActive(parameters)) {
                return;
            }

            // eslint-disable-next-line new-cap
            const component = new description.class(parameters);
            component.setAlignment(styles);
            this.addChild(component, styles.zOrder);
        });

        const visibleControls = ["MenuBarGoldItem", "MenuBarLivesItem"];

        cleverapps.focusManager.showControlsWhileFocused(visibleControls);
    }
});